/**
 * Logging utilities
 * Centralizes common logging patterns
 */

/**
 * Truncate UID for safe logging (first 8 characters + "...")
 * Prevents logging full UIDs which can be sensitive or too verbose
 * @param uid - UID to truncate
 * @param length - Length of prefix (default: 8)
 * @returns Truncated UID or empty string if invalid
 */
export function truncateUidForLogging(uid: string | null | undefined, length: number = 8): string {
	if (!uid || typeof uid !== "string" || uid.length <= length) {
		return uid || "";
	}
	return `${uid.substring(0, length)}...`;
}
